/**
 * 生产环境按业务板块做代码分割
 * @example: webpackChunkName: 'homepage', 'homepage'即为拆分的模块名
 * this generates a separate chunk (homepage.[hash].js) for this route.
 * which is lazy-loaded when the route is visited.
 *
 * 配置项： 默认值
 * name:'RouterName'              name为路由唯一标记，作为路由跳转或提供keep-alive功能识别，其name请保持和组件内name一致 (must set!!!).
 * meta : {
    title: 'title'                在菜单栏显示的名字
    savedPosition: { x: 0, y: 0 } 页签缓存的滚动条位置
    icon: 'svg-name'              当有icon时，会在菜单上显示，icon对应src/icons/svg/下.svg文件名
    noCache: true,                是否取消缓存 (只对一级路由生效，如'Homepage')
  }
 */

import { HOMEPAGE } from '../types';

export default {
    name: `${HOMEPAGE}`,
    path: '/homepage',
    component: () => import(/* webpackChunkName: 'homepage' */ '@/views/homepage/'),
    redirect: { name: `${HOMEPAGE}Index` },
    meta: {
        title: '首页',
        // 页签缓存的滚动条位置
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${HOMEPAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'homepage' */ '@/views/homepage/home/Home.vue'),
        },
        {
            name: `${HOMEPAGE}GroupDetail`,
            path: 'group/detail',
            permission: true,
            component: () => import(/* webpackChunkName: 'homepage' */ '@/views/homepage/groupDetail/index.vue'),
        },
    ],
};
